module.exports = __webpack_public_path__ + "img/code1.7eee5343.png";